import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const cluster: RouteRecordItem = {
  path: '/cluster',
  name: 'Cluster',
  component: LAYOUT,
  redirect: { name: 'ClusterDetail' },
  meta: {
    orderNo: 2,
    icon: 'ant-design:cluster-outlined',
    title: t('routes.cluster.集群管理'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'detail',
      name: 'ClusterDetail',
      component: () => import('@/pages/cluster/index.vue'),
      meta: {
        title: t('routes.cluster.集群管理'),
      },
    },
  ],
}

export default cluster
